module.exports = __webpack_public_path__ + "media/images/Canada-groom-image1-d0be2b330468f5b3298c96e191318078.jpg";